<template>
  <div v-if="show" class="mask" style="z-index: 99999;">
    <div class="dlg-show1 flex flex-center-sp flex-center-cz">
      <div class="font-l font-bold">{{msg}}</div>
    </div>
  </div>
</template>
 
<script>

export default {
    name: 'Toast',//组件递归必须有name属性 不然无法递归    
    props: {
        show: {},
        msg:{},
        duration: {}
      
    },
    data() {
        return {
          timerDuration: null
        }
    },
    watch: {
      show(n) {
          if (!n && this.timerDuration) {
              clearTimeout(this.timerDuration)
              this.timerDuration = null
          }
      }

    },
    methods: {
      init() {
          document.addEventListener("click", this.close, false);// 添加监听点击事件
          window.event.stopPropagation();
          this.show = true
          if (this.duration!=null && this.duration>0) {
              this.timerDuration = setTimeout(() => {
                this.show = false
              }, this.duration)
          }
      },
      clear() {
          this.show = false
      },
      close() {
          document.removeEventListener("click", this.close, false);//关闭监听点击事件
          this.show = false;
      } 

    }
}
</script>

<style scoped>
    .dlg-show1 {
        border-radius: 5px;
        min-width: 250px;
        max-width: 400px;
        background-color: #ffffff;
        padding: 20px;
        height: 30px;
        position: absolute;
        margin-left: auto;
        margin-right: auto;
        top: 40px;
        left: 0;
        right: 0;
        bottom: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/dialog/Toast.vue